import React from 'react';

const BusinessLoans = () => {
  return (
    <div style={{ padding: '50px', fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif", lineHeight: '1.8' }}>
      <h1 style={{ fontSize: '36px', marginBottom: '20px', color: '#22225f' }}>Business Loans</h1>
      <p>
        Our Business Loan solutions are designed to support businesses of all sizes in achieving their goals. Whether you
        are expanding operations, purchasing new equipment, or managing working capital, our loans come with competitive
        interest rates and tailored repayment terms.
      </p>
      <h2 style={{ fontSize: '28px', color: '#22225f', marginTop: '30px' }}>Features and Benefits</h2>
      <ul style={{ paddingLeft: '20px', listStyleType: 'disc' }}>
        <li>Flexible loan amounts based on your business needs.</li>
        <li>Competitive interest rates to reduce financial burden.</li>
        <li>Quick and hassle-free approval process.</li>
        <li>Personalized repayment schedules to suit cash flow.</li>
      </ul>
    </div>
  );
};

export default BusinessLoans;
